import {
  IconArrowsLeftRight,
  IconBuildingBank,
  IconCalendarEvent,
  IconCoins,
  IconGift,
  IconHome,
  IconReceipt2,
  IconShoppingCart,
  IconTools,
  IconTrees,
  type Icon,
} from '@tabler/icons-react';

const EXPENSE_CATEGORY_ICONS: Record<string, Icon> = {
  FIXED_COSTS: IconReceipt2,
  DAILY_LIFE: IconShoppingCart,
  WORKS_EQUIPMENT: IconTools,
  FUNDING_CALLS: IconCoins,
  RENTAL_HOUSING: IconHome,
  EVENTS_TOURISM: IconCalendarEvent,
  ESTATE_LANDS: IconTrees,
  OPERATING: IconBuildingBank,
  SUBSIDIES: IconGift,
  REIMBURSEMENTS: IconArrowsLeftRight,
};

export const INCOME_CATEGORY_ICON: Icon = IconCoins;

export const getCategoryIcon = (mainCategory: string, isIncome: boolean): Icon => {
  if (isIncome) return INCOME_CATEGORY_ICON;
  return EXPENSE_CATEGORY_ICONS[mainCategory] ?? IconCoins;
};
